




















































































































import { Component, Watch } from 'vue-property-decorator';
import { namespace, State, Mutation  } from 'vuex-class';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwApp } from '@libs-uuif/shared/sw-app';
import { cscApiService } from '@/shared/api-service/csc-api-service';
import { CoreStoreState } from '@/core/core.store';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { localStorageKeeperService } from '@/shared/auth-service';
import { UnifiedInsightsStoreState } from '../../modules/unified-insights/unified-insights.store';
import { widgets } from '../../modules/unified-insights/widgets-configuration/default-widgets/widgets';
import { unifiedMessageContainer } from '@/shared/constants';
import { messageService } from '@libs-uuif/shared/message-service';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import { SwAppHeader } from '../sw-app-header';
import { SwAppNav } from '../sw-app-nav';
import { SwAppContent } from '../sw-app-content';
import _ from 'lodash';
import DevicePickerSlide from './components/device-picker-slide.vue';
import { nsmApiService } from '@/shared/api-service/nsm-api-service';
import { ccApiService } from '@/shared/api-service/cc-api-service';
import { RootStoreState } from '@/store';
import { envCongif } from '@/shared/env.config';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { qsgDataStructure } from '@/core/sw-qsg/sw-qsg-data-structure';
import { SwQuickStartGuide } from '@/core/sw-qsg';
import { Base64 } from 'js-base64';
import { UserList } from '@/shared/types/userlist.type';

const cssPrefix = 'sw-app-main';
const unifiedInsightsStoreModule = namespace('UnifiedInsightsStoreModule');
const TENENT_SERIAL: string = 'tenantserial';

@Component({
  components: {
    SwApp,
    SwAppHeader,
    SwAppNav,
    SwAppContent,
    SwBlockingProgress,
    DevicePickerSlide,
    SwIcon,
    SwQuickStartGuide,
  },
})
export default class SwAppMain extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Mutation
  setTenantList: VuexMappedMutation<CoreStoreState['tenantList']>;

  @Mutation
  setArrTenantOptions: VuexMappedMutation<CoreStoreState['arrTenantOptions']>;

  @Mutation
  setTenantName: VuexMappedMutation<CoreStoreState['tenantName']>;

  @Mutation
  setTenantSerial: VuexMappedMutation<CoreStoreState['tenantSerial']>;

  @Mutation
  setTenant: VuexMappedMutation<CoreStoreState['tenant']>;

  @Mutation
  setProductList: VuexMappedMutation<CoreStoreState['productList']>;

  @Mutation
  setTenantGroups: VuexMappedMutation<CoreStoreState['tenantGroups']>;

  @Mutation
  setDeviceHierarchy: VuexMappedMutation<CoreStoreState['deviceHierarchy']>;

  @Mutation
  setNavigateUrl: VuexMappedMutation<CoreStoreState['navigateUrl']>;

  @Mutation
  setCurrentCcTenantId: VuexMappedMutation<CoreStoreState['currentCcTenantId']>;

  @Mutation
  setNsmBaseUrl: VuexMappedMutation<CoreStoreState['nsmBaseUrl']>;

  @Mutation
  setCcBaseUrl: VuexMappedMutation<CoreStoreState['ccBaseUrl']>;

  @Mutation
  setWirelessBaseUrl: VuexMappedMutation<CoreStoreState['wirelessBaseUrl']>;

  @Mutation
  setUserList: VuexMappedMutation<CoreStoreState['userList']>;

  @Mutation
  setNsmTenentMode: VuexMappedMutation<CoreStoreState['nsmTenentMode']>;

  @Mutation
  setNsmTenentID: VuexMappedMutation<CoreStoreState['nsmTenentID']>;

  @unifiedInsightsStoreModule.Mutation
  assignWidget: VuexMappedMutation<UnifiedInsightsStoreState['widgets']>;

  @unifiedInsightsStoreModule.Mutation
  setFixDashboardWidgetsLayout: VuexMappedMutation<
    UnifiedInsightsStoreState['fixDashboardWidgetsLayout']
  >;

  @unifiedInsightsStoreModule.Mutation
  setSavedDashboardLayout: VuexMappedMutation<
    UnifiedInsightsStoreState['savedDashboardLayout']
  >;

  @State((state: RootStoreState) => state.CoreStoreModule.tenant)
  tenant: CoreStoreState['tenant'];

  @State((state: RootStoreState) => state.CoreStoreModule.tenantName)
  tenantName: CoreStoreState['tenantName'];

  @State((state: RootStoreState) => state.CoreStoreModule.tenantList)
  tenantList: CoreStoreState['tenantList'];

  @State((state: RootStoreState) => state.CoreStoreModule.productList)
  productList: CoreStoreState['productList'];

  @State((state: RootStoreState) => state.CoreStoreModule.devicePickerSlideVisible)
  devicePickerSlideVisible: CoreStoreState['devicePickerSlideVisible'];

  @State((state: RootStoreState) => state.CoreStoreModule.selectedNavItemId)
  selectedNavItemId: CoreStoreState['selectedNavItemId'];

  @State((state: RootStoreState) => state.CoreStoreModule.navigateUrl)
  navigateUrl: CoreStoreState['navigateUrl'];

  @State((state: RootStoreState) => state.CoreStoreModule.nsmBaseUrl)
  nsmBaseUrl: CoreStoreState['nsmBaseUrl'];

  @State((state: RootStoreState) => state.CoreStoreModule.ccBaseUrl)
  ccBaseUrl: CoreStoreState['ccBaseUrl'];

  @State((state: RootStoreState) => state.CoreStoreModule.userList)
  userListValue: CoreStoreState['userList'];

  @State((state: RootStoreState) => state.CoreStoreModule.wirelessBaseUrl)
  wirelessBaseUrl: CoreStoreState['wirelessBaseUrl'];

  @State((state: RootStoreState) => state.CoreStoreModule.arrTenantOptions)
  arrTenantOptions: CoreStoreState['arrTenantOptions'];

  @State((state: RootStoreState) => state.CoreStoreModule.reloadWidgets)
  reloadWidgets: CoreStoreState['reloadWidgets'];

  @unifiedInsightsStoreModule.State
  selectedUserInDashboard: UnifiedInsightsStoreState['selectedUserInDashboard'];

  @unifiedInsightsStoreModule.Mutation
  setSelectedUserInDashboard: VuexMappedMutation<
    UnifiedInsightsStoreState['selectedUserInDashboard']
  >;

  isLoading: boolean = true;
  isNsmTokenFetched: boolean = false;
  isCcTokenFetched: boolean = false;
  isNsmTenantActivated: boolean = false;
  isCcTenantActivated: boolean = false;
  isWcmTokenFetched: boolean = false;
  isWcmTenantActivated: boolean = false;
  isDashboardFetched: boolean = false;
  sonicwallProducts = ['NGMGMT', 'Capture Client', 'Wireless'];
  nsmTenantsData: any = [];
  ccTenantsData: any = [];
  showSpogCurtain : boolean = false;
  defconDialogSrc : string = '';
  interval: any;

  async created() {
    window.addEventListener('message', (e : Event) => {
      this.spogEventListner(e);
    });
    this.showSpogCurtain = window.location.href.indexOf('unified-insights') > -1 ? true : false;
    if (this.showSpogCurtain) {
      if (window.location.hostname.toLowerCase()
    .indexOf('localhost') >= 0) {
        this.defconDialogSrc = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/workspace/m/feature/spog-homepage?embed=YES`;
      } else {
        this.defconDialogSrc = `${envCongif.spog_url}/workspace/m/feature/spog-homepage?embed=YES`;
      }
      console.warn(this.defconDialogSrc);
    }
    await this.fetchTenantList();
    this.interval = setInterval(
      () => {
        cscApiService.validateToken();
      },
      30000,
    );
  }
  beforeDestroy() {
    clearInterval(this.interval);
  }

  /**
   * @desc Fetch the tenants available to the user
   */
  async fetchTenantList() {
    await cscApiService
      .getCloudTenants()
      .then((response) => {
        if (response.operationStatus !== 'OK') {
          throw new Error(response.msgDesc);
        }
        this.setTenantList(response.content.arrTenants);
        this.setTenantName(localStorageKeeperService.retrieve('tenantname'));
        this.setTenant(localStorageKeeperService.retrieve('tenant'));
        this.setArrTenantOptions(response.content.arrTenantOptions);
        const tempTenantList = this.tenantList.filter((tenant) => {
          const productList = _.map(
            _.filter(tenant?.cloudServices, { isEnabled: true }),
            'serviceName',
          );
          const filteredProductList = _.remove(productList, (product) => {
            return this.sonicwallProducts.includes(product);
          });
          return filteredProductList.length > 0;
        });
        this.setDeviceHierarchy(this.makeTenantHierarchy(tempTenantList));
      })
      .catch((error) => {
        this.isLoading = false;
        console.error('Cloud Tenants API error', error);
      });
  }

  /**
   * @desc Will be used to set the value of the product's sso fetched flag
   * @param product service name of the product of which sso api has been called
   * @param value flag value for that product
   */
  setFlag(product: string, value: boolean) {
    switch (product) {
      case 'NGMGMT':
        this.isNsmTokenFetched = value;
        break;
      case 'Capture Client':
        this.isCcTokenFetched = value;
        break;
      case 'Wireless':
        this.isWcmTokenFetched = value;
        break;
      case 'NGMGMT-tenantActivated':
        this.isNsmTenantActivated = value;
        break;
      case 'Capture Client-tenantActivated':
        this.isCcTenantActivated = value;
        break;
      case 'Wireless-tenantActivated':
        this.isWcmTenantActivated = value;
        break;
      default:
        return;
    }
    if (
      this.isNsmTokenFetched &&
      this.isCcTokenFetched &&
      this.isNsmTenantActivated &&
      this.isCcTenantActivated &&
      this.isWcmTokenFetched &&
      this.isWcmTenantActivated &&
      this.isDashboardFetched
    ) {
      this.isLoading = false;
    }
  }

  @Watch('reloadWidgets')
  reloadWidgetChange() {
    this.fetchTenantDashboardLayout();
  }

  @Watch('selectedUserInDashboard')
  selectedUserChanged(newValue: any, oldValue: any) {
    if (newValue !== '' && oldValue !== '') {
      this.fetchDashboardLayoutForUser(this.selectedUserInDashboard);
    }
  }

  /**
   * @desc Filter out the products available to the tenant
   */
  @Watch('tenantName', { immediate: true })
  tenantNamefetchTenantProducts() {
    this.isNsmTokenFetched = false;
    this.isCcTokenFetched = false;
    this.isNsmTenantActivated = false;
    this.isCcTenantActivated = false;
    this.isWcmTokenFetched = false;
    this.isWcmTenantActivated = false;
    this.isLoading = true;
    if (this.tenantName) {
      const tempProductList = [
        ..._.map(
          _.filter(
            this.tenantList?.find(tenant => tenant.name === this.tenantName)
              ?.cloudServices,
            { isEnabled: true },
          ),
          'serviceName',
        ),
      ];
      this.sonicwallProducts.map((product) => {
        if (!tempProductList.includes(product)) {
          this.setFlag(product, true);
          this.setFlag(`${product}-tenantActivated`, true);
        }
      });
      if (tempProductList.length === 0) {
        this.isLoading = false;
      }
      this.setProductList(tempProductList);
      const selectedCscTenant = this.tenantList?.find(tenant => tenant.name === this.tenantName);

      const nsmNavigateUrl = (selectedCscTenant?.cloudServices
        .find((product: any) => product.serviceName === 'NGMGMT')?.navigateUrl) || '';
      this.setNavigateUrl(nsmNavigateUrl);
      this.setNsmBaseUrl(nsmNavigateUrl?.substring(0, nsmNavigateUrl.indexOf('/sso')) || '');
      let nsmTenentMode = (selectedCscTenant?.cloudServices
        .find((product: any) => product.serviceName === 'NGMGMT')?.serviceMode) || 'ESSENTIAL';
      nsmTenentMode = nsmTenentMode.toUpperCase();
      this.setNsmTenentMode(nsmTenentMode);
      const wirelessNavigateUrl = (selectedCscTenant?.cloudServices
        .find((product: any) => product.serviceName === 'Wireless')?.navigateUrl) || '';
      this.setWirelessBaseUrl(wirelessNavigateUrl);
    }
  }

  /**
   * @desc Fetch the Dashboard Layout for the selected tenant
   */
  @Watch('tenant', { immediate: true })
  async fetchTenantDashboardLayout() {
    this.isDashboardFetched = false;
    if (!(this.tenant?.length > 0)) {
      return;
    }
    this.isLoading = true;
    this.setSelectedUserInDashboard('');
    await cscApiService
    .getUserForTenant(this.tenant)
    .then((response) => {
      if (response.operationStatus === 'OK' || response.dashboardList?.length > 0) {
        let currentUser = response.dashboardList[0].username;
        const userList :UserList[]  = response.dashboardList.map((user : any) => {
          if (user.isCurrentUser) {
            currentUser = user.username;
          }
          return {
            id : String(user.username),
            label : String(user.dashBoardName),
            value : String(user.dashBoardName),
          };
        });
        const currentDashboardUser =  response.dashboardList.find((ele : any) => {
          return ele.isCurrentUser;
        }) || {};
        this.setUserList(userList);
        this.setSelectedUserInDashboard(currentUser);
        this.setDashboardLayoutForUser(currentDashboardUser.widgetData || '');
      }
    });
    // this.fetchDashboardLayoutForUser(this.selectedUserInDashboard);
  }

  fetchDashboardLayoutForUser(userName : any) {
    this.isLoading = true;
    cscApiService
      .getDashboardLayout({ tenantId: this.tenant, username : userName })
      .then((response) => {
        this.isDashboardFetched = true;
        if (this.isNsmTokenFetched && this.isCcTokenFetched && this.isWcmTokenFetched) {
          this.isLoading = false;
        }
        let dashboardWidgets = _.isEmpty(response.content)
          ? widgets
          : JSON.parse(Base64.decode(response.content.widgetData));
        let productDataGroupMapped = this.productList.map((product: any) => {
          if (product === 'NGMGMT') {
            return 'firewall';
          }
          if (product === 'Capture Client') {
            return 'capture client';
          }
          if (product === 'Wireless') {
            return 'wireless';
          }
          if (product === 'Switches') {
            return 'switches';
          }
          return '';
        });
        if (productDataGroupMapped &&
          productDataGroupMapped.length > 0 &&
          productDataGroupMapped.includes('wireless')) {
          productDataGroupMapped.push('switches');
        }
        if (productDataGroupMapped &&
          productDataGroupMapped.length > 0) {
          productDataGroupMapped = productDataGroupMapped.filter((ele: any) => { return ele !== ''; });
        }
        dashboardWidgets = dashboardWidgets.filter((widget: any) => {
          return productDataGroupMapped.includes(widget.dataGroup);
        });
        this.assignWidget(dashboardWidgets);
        this.setFixDashboardWidgetsLayout(true);
      })
      .catch((error) => {
        this.isLoading = false;
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          'Failed to fetch the dashboard layout, please try again after sometime',
          'failed',
        );
        console.error('Dashboard layout API error', error);
      });
  }

  setDashboardLayoutForUser(dashboardData: string) {
    this.isDashboardFetched = true;
    if (this.isNsmTokenFetched && this.isCcTokenFetched && this.isWcmTokenFetched) {
      this.isLoading = false;
    }
    let dashboardWidgets = dashboardData === ''
      ? widgets
      : JSON.parse(Base64.decode(dashboardData));
    let productDataGroupMapped = this.productList.map((product: any) => {
      if (product === 'NGMGMT') {
        return 'firewall';
      }
      if (product === 'Capture Client') {
        return 'capture client';
      }
      if (product === 'Wireless') {
        return 'wireless';
      }
      if (product === 'Switches') {
        return 'switches';
      }
      return '';
    });
    if (productDataGroupMapped &&
      productDataGroupMapped.length > 0 &&
      productDataGroupMapped.includes('wireless')) {
      productDataGroupMapped.push('switches');
    }
    if (productDataGroupMapped &&
      productDataGroupMapped.length > 0) {
      productDataGroupMapped = productDataGroupMapped.filter((ele: any) => { return ele !== ''; });
    }
    dashboardWidgets = dashboardWidgets.filter((widget: any) => {
      return productDataGroupMapped.includes(widget.dataGroup);
    });
    this.assignWidget(dashboardWidgets);
    this.setFixDashboardWidgetsLayout(true);
  }

  /**
   * @desc Get the SSO Token for the available products
   */
  @Watch('productList', { immediate: true })
  async productListSsoFetch() {
    await this.productList?.map(async (product) => {
      await cscApiService.fetchSsoTokens(
        product,
        this.tenant,
        this.setFlag,
        this.navigateUrl,
        this.setCcBaseUrl,
        this.nsmBaseUrl,
        this.wirelessBaseUrl,
        this.arrTenantOptions,
      );
      await this.activateCurrentTenant(product, this.setFlag);
    });
  }

  /**
   * @desc This function is used to create Tenant Hierarchy for tenant selector
   * @param tenantList List of CSC Tenants
   */
  makeTenantHierarchy(tenantList: any) {
    let tenantHierarchy = [];
    tenantHierarchy = tenantList.map((entry: any) => {
      if (entry.name) {
        return {
          id: entry.name,
          type: 'tenant',
          label: entry.name,
          children: [],
          isDefault: false,
          subtotal: 0,
          data: {},
        };
      }
    });
    return tenantHierarchy;
  }

  /**
   * @desc This function is used to activate current Tenant in available products
   * @param {string} product product to be used for activating tenant
   */
  async activateCurrentTenant(product: string, setFlag: any) {
    switch (product) {
      case 'NGMGMT':
        this.activateNsmTenant();
        break;
      case 'Capture Client':
        this.activateCcTenant();
        break;
      default:
        return;
    }
    setFlag(`${product}-tenantActivated`, true);
  }

  /**
   * @desc This function is used to activate NSM Tenant
   */
  async activateNsmTenant() {
    if (this.nsmTenantsData.length === 0) {
      await this.fetchNsmTenantsMappingData();
    }
    let serialNumberForNsm  = '';
    const tenantElementSelected = this.tenantList.find((tenant : any) => tenant.productGroupID.toString()
    .toLocaleLowerCase() === this.tenant.toLocaleLowerCase());
    const tenantSelected = tenantElementSelected.cloudServices.find((tenant : any) => tenant.serviceName === 'NGMGMT');
    if (tenantSelected?.isEnabled && tenantSelected?.navigateUrl) {
      const queryParams = new URLSearchParams(tenantSelected?.navigateUrl);
      serialNumberForNsm = (queryParams.has(TENENT_SERIAL) && queryParams.get(TENENT_SERIAL)) || '';
    }
    let currentTenant : any;
    if (serialNumberForNsm) {
      currentTenant = this.nsmTenantsData.find(
      (tenant: any) =>
        tenant.msw_tenant_id.toLocaleLowerCase() === serialNumberForNsm.toLocaleLowerCase(),
      );
    } else {
      currentTenant = this.nsmTenantsData.find(
      (tenant: any) =>
        tenant.name.toLocaleLowerCase() === this.tenantName.toLocaleLowerCase(),
      );
    }
    if (currentTenant && currentTenant.id) {
      nsmApiService
        .activateTenant([currentTenant.id])
        .then((response) => {
          if (!response.status.success) {
            throw new Error();
          }
          this.setTenantSerial(
            currentTenant.msw_tenant_id ? currentTenant.msw_tenant_id : '',
          );
          this.setNsmGroups();
          this.setNsmTenentID(currentTenant.id);
        })
        .catch((error) => {
          this.setTenantGroups([]);
          console.error('NSM activate tenant API error', error);
        });
    } else {
      this.setTenantGroups([]);
    }
  }

  /**
   * @desc This function is used to fetch NSM tenants, required for mapping the tenant IDs
   */
  async fetchNsmTenantsMappingData() {
    await nsmApiService
      .getAllTenants()
      .then((response) => {
        if (response.length === 0) {
          throw new Error();
        }
        this.nsmTenantsData = response;
        const currentTenant = this.nsmTenantsData.find((tenant: any) => {
          return tenant.name.toLocaleLowerCase() === this.tenantName.toLocaleLowerCase();
        });
        this.setNsmTenentID(currentTenant.id);
      })
      .catch((error) => {
        console.error('NSM fetch tenants API error', error);
      });
  }

  /**
   * @desc This function is used to activate CC Tenant
   */
  async activateCcTenant() {
    if (this.ccTenantsData.length === 0) {
      await this.fetchCcTenantsMappingData();
    }
    const currentTenant = this.ccTenantsData.find((tenant: any) => {
      return tenant.tenantName
        .toLocaleLowerCase()
        .includes(this.tenantName.toLocaleLowerCase());
    });
    if (currentTenant && currentTenant.tenantId) {
      ccApiService
        .activateTenant(currentTenant.tenantId)
        .then((response) => {
          this.setCurrentCcTenantId(currentTenant.tenantId);
          return response;
        })
        .catch((error) => {
          console.error('CC activate tenant API error', error);
        });
    }
  }

  /**
   * @desc This function is used to fetch CC tenants, required for mapping the tenant IDs
   */
  async fetchCcTenantsMappingData() {
    await ccApiService
      .getAllTenants()
      .then((response: any) => {
        if (
          !response ||
          !response.multiTenants ||
          !response.multiTenants.tenantRoles
        ) {
          throw new Error();
        }
        this.ccTenantsData = response.multiTenants.tenantRoles;
      })
      .catch((error) => {
        console.error('CC fetch tenants API error', error);
      });
  }

  /**
   * @desc This function is used to store current NSM tenant Groups
   */
  setNsmGroups() {
    nsmApiService
      .getTenantGroups()
      .then((response) => {
        const groupsData = response.map((group: any) => {
          if (group.groupID && group.friendlyName) {
            let innerGroupDevices: any = [];
            if (group.deviceGroups) {
              innerGroupDevices = this.fetchInnerDevices(
                response,
                group.deviceGroups,
                [group.groupID],
              );
            }
            const groupDevices = group.devices ? group.devices : [];
            return {
              groupId: group.groupID,
              groupName: group.friendlyName,
              devices: [...groupDevices, ...innerGroupDevices] || [],
            };
          }
        });
        this.setTenantGroups(groupsData);
      })
      .catch((error) => {
        this.setTenantGroups([]);
        console.error('NSM fetch tenant groups API error', error);
      });
  }

  /**
   * @desc This function is used to fetch the devices in the inner groups
   * @param groupsData Reponse groups data
   * @param innerGroups inner Groups
   * @param visitedGroup visited groups
   */
  fetchInnerDevices(groupsData: any, innerGroups: any, visitedGroup: any) {
    if (!innerGroups) {
      return [];
    }
    let innerGroupDevices: any = [];
    innerGroups.map((innerGroupId: any) => {
      if (visitedGroup.includes(innerGroupId)) {
        return;
      }
      const innerGroup = groupsData.find(
        (responseGroup: any) => responseGroup.groupID === innerGroupId,
      );
      innerGroup &&
        innerGroup.devices &&
        (innerGroupDevices = [...innerGroupDevices, ...innerGroup.devices]);
      innerGroup &&
        innerGroup.deviceGroups &&
        (innerGroupDevices = [
          ...innerGroupDevices,
          ...this.fetchInnerDevices(groupsData, innerGroup.deviceGroups, [...visitedGroup, innerGroupId]),
        ]);
    });
    return innerGroupDevices;
  }
  toggleCurtain(close : any) {
    const curtain = this.$refs.curtain as HTMLElement;
    const overlay = this.$refs.overlay as HTMLElement;
    const innerVerticalPuller = this.$refs.innerVerticalPuller as HTMLElement;
    const outerVerticalPuller = this.$refs.outerVerticalPuller as HTMLElement;
    if (close) {
      curtain.style.top = '-100%';
      overlay.style.display = 'none';
      outerVerticalPuller.classList.remove('msw-app-content-hidden');
      outerVerticalPuller.style.transform = 'rotate(180deg)';
      innerVerticalPuller.style.transform = 'rotate(180deg)';
    } else {
      outerVerticalPuller.style.transform = 'rotate(360deg)';
      innerVerticalPuller.style.transform = 'rotate(360deg)';
      curtain.style.top = '0';
      overlay.style.display = 'block';
      outerVerticalPuller.classList.add('msw-app-content-hidden');
    }
  }
  spogEventListner(event : any) {
    if (event.data.closeCurtain) {
      this.toggleCurtain(true);
      const curtainFrame = this.$refs.mswCurtainFrame as HTMLFrameElement;
      if (curtainFrame !== null) {
        curtainFrame.contentWindow!.postMessage({
          closedCurtain: true,
          service: event.data.service,
          navigateUrl: event.data.navigateUrl,
        },                                      '*');
      }
    }
  }
  get qsgData() {
    return qsgDataStructure;
  }
}
